import { StepBase } from './StepBase';
import { PageStepType } from './PageTypes';
import * as StepTypes from './StepTypes';
import { LogicEngine } from '../LogicEngine/LogicEngine';
import { FieldError } from '../utils/DataDictionary';
import { StepChart } from './StepChart';
export abstract class PageRenderBase
{
	/* Reference to the logicEngine needed for this page */
	logicRef: LogicEngine | undefined;

	/* Reference to the current form if a form is active */
	formOptRef: StepTypes.Form | undefined;

	/**
	 *   Render functions that the implementation should provide.
	 */
	abstract renderText(opt: StepTypes.Text): void;
	abstract renderBreak(opt: StepTypes.Break): void;
	abstract renderButton(opt: StepTypes.Button): void;

	abstract startSection(opt: StepTypes.Section): void;
	abstract endSection(opt: StepTypes.Section): void;

	abstract startGroup(opt: StepTypes.Group): void;
	abstract endGroup(opt: StepTypes.Group): void;

	abstract renderDashStat(opt: StepTypes.DashStat): void;
	abstract renderDashButton(opt: StepTypes.DashButton): void;

	abstract renderUnknown(opt: PageStepType): void;

	abstract renderTable(opt: StepTypes.Table): void;

	abstract renderTabs(opt: StepTypes.Tabs): void;

	abstract renderFormStart(opt: StepTypes.Form): void;
	abstract renderFormEnd(opt: StepTypes.Form): void;
	abstract renderFormField(opt: StepTypes.Form, field: StepTypes.Form.FieldInfo): void;

	/* Called when a list is started */
	abstract renderListStart(opt: StepTypes.List): void;
	abstract renderListEnd(opt: StepTypes.List): void;
	abstract renderListItemStart(opt: StepTypes.List): void;
	abstract renderListItemEnd(opt: StepTypes.List): void;

	/** Called when a chart is started */
	renderChartStart(opt: StepChart): void
	{
	}

	/** Called when a chart is started */
	renderChartEnd(opt: StepChart): void
	{
	}

	renderTestCase(opt: StepTypes.Test): void
	{
	}

	/** Called when a window is started */
	renderWindow(opt: StepTypes.Window): void
	{
	}

	/** Render debug output in trace mode for the admin */
	renderTrace(opt: StepTypes.Text, row: number): void
	{
		console.log("TRACE:", opt.text);
	}

	/** Render a block of code from Begin Code // End Code */
	renderCodeBlock(opt: PageStepType, name: string, codeBlock: PageStepType[]): void
	{
		console.log("Code Block name:", name);
		console.log("Code Block:", codeBlock);
	}

	/** Pass in an object with data fields
	 * and this will fill out the form as if typed by the keyboard.
	 * This function does not handle validation.
	 *
	 * @example
	 * r.fillOutForm({
	 *      first_name : "Brian",
	 *      last_name  : "Pollack"
	 * });
	 */
	async fillOutForm(formData: any): Promise<void>
	{
		if (!this.formOptRef) return;

		this.debugMessage('');
		this.debugMessage('Filling out form with data');

		this.formOptRef.fields.forEach((e) =>
		{
			if (!e.field) return;
			if (formData[e.field] !== undefined && this.formOptRef)
			{
				this.debugForm(e.field, formData[e.field]);
				this.formOptRef.setValueFromUser(e.field, formData[e.field]);
			} else
			{
				console.warn('fillOutForm unable to find field [', e.field, ']');
			}
		});
	}

	/** Called upon starting */
	onInit(logic: LogicEngine) { }

	async submitForm(ignore_warnings: boolean): Promise<FieldError[]>
	{
		this.debugMessage('');
		this.debugMessage('Submitting form data');

		if (this.formOptRef && this.formOptRef.record)
		{
			let results = await this.formOptRef.save(ignore_warnings);
			if (results && results.length > 0)
			{
				results.forEach((e) =>
				{
					this.debugMessage(
						'Validation error in field ' + e.field_name + ': ' + e.error_message,
					);
				});

				return results;
			}

			this.debugMessage('Save complete, no validation errors.');
			return [];
		} else
		{
			if (!this.formOptRef)
			{
				console.log('PageRenderBase Something went wrong, formOptRef not set');
			} else
			{
				console.log('PageRenderBase Something went wrong, formOptRef.record not set.');
			}

			this.debugMessage("this.formOptRef or this.formOptRef.record not set, can't save.");
			throw 'Internal error, unable to submit form to server.';
			return [];
		}
	}

	debugForm(variableName: string, dataValue?: any | undefined) { }

	debugMessage(message: string) { }

	debugStep(opt: StepTypes.Base)
	{
		// console.log("PageRenderBase::Debug Step=", opt);
	}
}

export class PageRenderSilent extends PageRenderBase
{
	renderText(opt: StepTypes.Text): void
	{
	}

	renderBreak(opt: StepTypes.Break): void
	{
	}

	renderButton(opt: StepTypes.Button): void
	{
	}

	startGroup(opt: StepTypes.Group): void
	{
	}

	endGroup(opt: StepTypes.Group): void
	{
	}

	startSection(opt: StepTypes.Section): void
	{
	}

	endSection(opt: StepTypes.Section): void
	{
	}

	renderDashStat(opt: StepTypes.DashStat): void
	{
	}

	renderDashButton(opt: StepTypes.DashButton): void
	{
	}

	renderTable(opt: StepTypes.Table): void
	{
	}

	renderUnknown(opt: PageStepType): void
	{
	}

	renderTabs(opt: StepTypes.Tabs): void
	{
	}

	renderFormStart(opt: StepTypes.Form): void
	{
	}

	renderFormEnd(opt: StepTypes.Form): void
	{
	}

	renderFormField(opt: StepTypes.Form, field: StepTypes.Form.FieldInfo): void
	{
	}

	renderListStart(opt: StepTypes.List): void
	{
	}

	renderListEnd(opt: StepTypes.List): void
	{
	}

	renderListItemStart(opt: StepTypes.List): void
	{
	}

	renderListItemEnd(opt: StepTypes.List): void
	{
	}

	debugStep(opt: StepTypes.Base)
	{
	}
};
